exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".origin-node[data-v-60a22c24]{border:1px solid #39a71b}", ""]);

// exports
